/**
 * Weight-action copy — the mode pills and the plain-words caption. The caption
 * is the client's only explanation of the math, so it spells the behaviour out
 * in full sentences (shared total, split by score, what everyone else gets).
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FlowLayer, RuleWeightConfig } from '@trafficpulse/shared';

export const WEIGHT_MODE_OPTIONS = [
  { value: 'static', label: 'Static pin' },
  { value: 'dynamic', label: 'Dynamic boost' },
] as const;

const NOUN: Record<FlowLayer, string> = {
  paths: 'paths',
  landers: 'landers',
  offers: 'offers',
};

export function weightNoun(appliesTo: ReadonlyArray<FlowLayer>): string {
  if (appliesTo.length === 0) return 'elements';
  return appliesTo.map((l) => NOUN[l]).join(' / ');
}

/** One full sentence describing exactly what the numbers will do. */
export function weightCaption(
  config: RuleWeightConfig,
  appliesTo: ReadonlyArray<FlowLayer>,
): string {
  const noun = weightNoun(appliesTo);
  if (config.mode === 'static') {
    return (
      `All matched ${noun} together are pinned to ${config.percent}% of their ` +
      `pool, split by score (better performers take more). Everyone else ` +
      `shares the remaining ${100 - config.percent}%.`
    );
  }
  return (
    `All matched ${noun} together share +${config.percent} percentage points ` +
    `on top of the weights the optimizer calculated (split by score). The ` +
    `others give up that share — scaled down automatically if it can't fit.`
  );
}
